export default "__VITE_ASSET__MDkCbMMK__"